import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Observable } from 'rxjs';

import { CompanyService } from '@app/core/client-user';
import { Assignee } from '@app/core/client-user/store/company.model';

@Component({
  selector: 'filter-sales-rep-assignee',
  templateUrl: './filter-sales-rep-assignee.component.html',
  styleUrls: ['./filter-sales-rep-assignee.component.scss'],
})
export class FilterSalesRepAssigneeComponent implements OnInit {
  constructor(public companySvc :CompanyService) {}

  @Input() value :number;
  @Input() label :string = 'Sales Rep Assignee';
  @Output() changeSalesRepAssignee :EventEmitter<number[] | number> =
    new EventEmitter<number[] | number>();
  @Input() options :{ multi :boolean } = { multi: true };
  assignees$ :Observable<Assignee[]>;

  ngOnInit() :void {
    this.assignees$ = this.companySvc.assignee$;
  }

  onChange() {
    this.changeSalesRepAssignee.emit(this.value);
  }

  customSearchFn(term :string, item :Assignee) {
    term = term.toLocaleLowerCase();
    const emailFound = item.email
      .toLowerCase()
      .replace(/&nbsp;/gi, '')
      .includes(term);
    const nameFound = (
      item.firstname.toLowerCase().replace(/&nbsp;/gi, '') +
      ' ' +
      item.lastname.toLowerCase().replace(/&nbsp;/gi, '')
    ).includes(term);

    return emailFound || nameFound;
  }
}
